export const TELEGRAM_URL = "https://web.telegram.org/";
export const TELEGRAM_DOBROPOST_URL = "https://t.me/dobropost_chat";
export const WHATSAPP_URL = "https://www.whatsapp.com/";
export const VK_URL = "https://vk.com/";
export const VK_DOBROPOST_URL = "https://vk.com/dbrpst";
export const INSTAGRAM_DOBROPOST_URL =
  "https://www.instagram.com/dobropostcom/";

export const LANGUAGE_TYPES = {
  RU: "ru",
  EN: "en",
  CN: "cn",
};

export const LANGUAGE_OPTIONS = {
  RU: "Рус",
  EN: "Eng",
  CN: "中文",
};

export const BASE_URL_PARCEL =
  "https://api.dobropost.com/api/tracking/parcel?key=b4538f528e7a957bd734fdeeab12d143";

export const SHIPMENT_BASE_URL =
  "https://api.dobropost.com/api/tracking/shipment?key=b4538f528e7a957bd734fdeeab12d143";

export const ESTIMATION_TIME = 14;

export const PARCEL_STATUSES = {
  READY_FOR_SENT: "READY_FOR_SENT",
};
